// Client-side checks for menu documents (prototype `impStart`), repeated on the server by content.

export const IMPORT_ACCEPT = ".pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/jpeg,image/png,image/webp";
const MAX_BYTES = 20 * 1024 * 1024;
export const MAX_IMPORT_FILES = 10;

const TYPES: Record<string, string> = {
  pdf: "application/pdf",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  webp: "image/webp",
  // iPhone photos copied to a computer; phones themselves hand the browser JPEG (see docs/PREGATIRE_DOCUMENTE.md).
  heic: "image/heic",
  heif: "image/heif",
};

const ext = (name: string) => (name.split(".").pop() ?? "").toLowerCase();

/** Prototype messages; null when the file can be uploaded. */
export function importFileError(file: File): string | null {
  if (!TYPES[ext(file.name)])
    return `Fișierul .${ext(file.name)} nu este acceptat. Folosește PDF, JPG, PNG, WebP sau o fotografie HEIC.`;
  if (file.size === 0) return "Fișierul este gol.";
  if (file.size > MAX_BYTES)
    return `Fișierul are ${(file.size / 1048576).toFixed(1).replace(".", ",")} MB. Limita este 20 MB.`;
  return null;
}

export const sizeLabel = (bytes: number) =>
  bytes < 1048576
    ? `${Math.max(1, Math.round(bytes / 1024))} KB`
    : `${(bytes / 1048576).toFixed(1).replace(".", ",")} MB`;
